import React from 'react';
import { ThemeProvider } from '@fluentui/react-theme-provider';
import { TruckingAutoLiability } from './components/TruckingAutoLiability'
import { initializeIcons } from '@uifabric/icons';

initializeIcons();

function App() {
	return (
		<ThemeProvider>
			<TruckingAutoLiability />
		</ThemeProvider>
	);
}

export default App;